import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderLogo from "../../utils/images/header-logo.png";
// import SearchIcon from "../../utils/images/search-icon.svg";
import MenuIcon from "../../utils/images/menu-icon.svg";
import BackIcon from "../../utils/images/arrow-white.svg";
import { status } from "../../_constants/common";
import { getCurrentUser, isAuthenticated, logout } from "../../utils/auth";
import DashboardIcon from "../../utils/images/dashboard_icon.png";
import CreateIcon from "../../utils/images/Collaborations_icon.png";
import CreateIcon2 from "../../utils/images/Received_icon.png";
import CreateIcon3 from "../../utils/images/Create_icon3.png";
import CreateIcon4 from "../../utils/images/Create_icon4.png";
import settings from "../../utils/images/settings.png";
import {
  fetchUnreadCount,
  fetchUserNotifications,
} from "../../Redux_Toolkit/Notification/NotificationsThunk";
import { setUnreadCount } from "../../Redux_Toolkit/Notification/NotificationsSlice";
import merchanticon from "../../utils/images/merchant-icon.png";
// import logout from "../../utils/images/logout.png";
import Received_icon from "../../utils/images/Received_icon.png";
import Proposals_icon from "../../utils/images/Proposals_icon.png";
import Collaborations_icon from "../../utils/images/Collaborations_icon.png";
import Promote_icon from "../../utils/images/Promote_icon.png";
import Exclusiveicon from "../../utils/images/Exclusive_icon.png";
import OrderListingicon from "../../utils/images/Order_Listing_icon.png";
import editicon from "../../utils/images/edit_icon.svg";
import { config as appConfig, config } from "../../config/config";
import history_icon from "../../utils/images/history_icon.png";
import { Helmet } from "react-helmet";
import { getInfluencerProfile } from "../../Redux_Toolkit/Influencer/InfluencerThunk";
import { getMerchantProfile } from "../../Redux_Toolkit/Merchant/MerchantThunk";
import Order_Listing_icon from "../../utils/images/Order_Listing_icon.png";
import payout_icon from "../../utils/images/payout_icon.png";
import reports_icon from "../../utils/images/reports_icon.png";
import transaction_icon from "../../utils/images/transaction_icon.png";
import Earnings_icon from "../../utils/images/Earnings_icon.png";

function Header(props) {
  const navigate = useNavigate();
  const API_BASE = appConfig.localApiUrl;
  const ASSET_BASE = API_BASE.replace(/\/api\/?$/, "");
  const { loggedInUser } = useSelector((state) => state.auth);
  const [menuOpen, setMenuOpen] = useState(false);
  const sidebarRef = useRef(null);
  const location = useLocation();
  const isUserAuthenticated = isAuthenticated();
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [hasProfileImageError, setHasProfileImageError] = useState(false);
  // const isActive = (path) => {
  //   return location.pathname === path ? "active" : "inactive";
  // }
  const cfg = props?.configData || {};

  // console.log("logo url:", cfg?.Merchant_header_logo ? `${ASSET_BASE}${cfg.Merchant_header_logo}` : HeaderLogo);

  const { unread, list } = useSelector((state) => state.notifications);
  const unreadCount = unread?.count || 0;
  const dispatch = useDispatch();
  const notifications = Array.isArray(list?.data) ? list.data : [];

  const normalizeRole = (value) =>
    typeof value === "string" ? value.trim().toLowerCase() : "";

  const isNotificationForCurrentRole = (notification, currentRole) => {
    const normalizedCurrentRole = normalizeRole(currentRole);
    if (!normalizedCurrentRole) return true;

    const receiverRole = normalizeRole(notification?.receiverRole);
    if (!receiverRole) return true;

    return receiverRole === normalizedCurrentRole;
  };

  // Get merchant profile to check business details
  const { merchantProfile } = useSelector((state) => state.merchant);
  const merchantData = merchantProfile?.data;

  // Get influencer profile
  const { profile } = useSelector((state) => state.influencer);

  const getUserData = () => {
    // First try Redux state
    if (loggedInUser?.data?.user) {
      return loggedInUser.data.user;
    }
    // Fallback to localStorage
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        return JSON.parse(storedUser);
      }
    } catch (e) {
      // console.error("Error parsing user from localStorage:", e);
    }
    return null;
  };

  const [localUser, setLocalUser] = useState(() => getUserData());
  const user = loggedInUser?.data?.user || localUser;
  // console.log("37---->", user);

  const userRole = user?.role;

  // Calculate role-filtered unread count
  useEffect(() => {
    const calculateRoleFilteredCount = () => {
      const userRole = user?.role;
      if (!userRole) return;

      const roleNotifications = notifications.filter(
        (n) => isNotificationForCurrentRole(n, userRole),
      );
      const roleUnreadCount = roleNotifications.filter((n) => !n.isRead).length;

      // console.log(HEADER - Calculating role-filtered count:');
      // console.log('Total notifications:', notifications.length);
      // console.log('Role-filtered:', roleNotifications.length);
      // console.log('Unread for role:', roleUnreadCount);

      if (roleUnreadCount !== unreadCount) {
        // console.log('HEADER - Updating Redux count to:', roleUnreadCount);
        dispatch(setUnreadCount(roleUnreadCount));
      }
    };

    if (notifications.length > 0) {
      calculateRoleFilteredCount();
    }
  }, [notifications, user?.role, dispatch, unreadCount]);

  useEffect(() => {
    // console.log('HEADER EFFECT - Running for location:', location.pathname);
    // Don't fetch on the notifications page - let that page handle it
    if (location.pathname !== "/notifications") {
      // console.log('HEADER - Not on notifications page, fetching notifications list');
      dispatch(fetchUserNotifications({ page: 1, limit: 1000 }));
    } else {
      // console.log('HEADER - On notifications page, skipping fetch (page handles it)');
    }

    const onChanged = () => {
      // console.log('HEADER - notifications:changed event received, fetching notifications');
      dispatch(fetchUserNotifications({ page: 1, limit: 1000 }));
    };
    window.addEventListener("notifications:changed", onChanged);

    return () => {
      // console.log('HEADER EFFECT - Cleaning up for location:', location.pathname);
      window.removeEventListener("notifications:changed", onChanged);
    };
  }, [dispatch, location.pathname]);

  // Simulate loading for skeleton
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // Fetch profile data on mount
  useEffect(() => {
    if (isAuthenticated()) {
      if (userRole === "influencer") {
        dispatch(getInfluencerProfile());
      } else if (userRole === "merchant") {
        dispatch(getMerchantProfile());
      }
    }
  }, [dispatch, userRole]);

  useEffect(() => {
    const handleUserUpdated = () => {
      // Re-read localStorage so user?.name stays fresh
      setLocalUser(getUserData());

      const currentUser = getCurrentUser();
      const currentRole = currentUser?.role;

      if (currentRole === "influencer") {
        dispatch(getInfluencerProfile());
      } else if (currentRole === "merchant") {
        dispatch(getMerchantProfile());
      }
    };

    window.addEventListener("user:updated", handleUserUpdated);
    return () => {
      window.removeEventListener("user:updated", handleUserUpdated);
    };
  }, [dispatch]);

  // Determine profile image based on user role
  const getProfileImage = () => {
    if (userRole === "merchant" && merchantProfile?.data?.profileImage) {
      return `${ASSET_BASE}${merchantProfile.data.profileImage}`;
    }
    if (userRole === "influencer" && profile?.data?.profileImage) {
      return `${ASSET_BASE}${profile.data.profileImage}`;
    }
    return null;
  };
  const profileImage = getProfileImage();

  useEffect(() => {
    setHasProfileImageError(false);
  }, [profileImage]);

  // Get display name based on role — returns null when no name is available
  const getDisplayName = () => {
    if (userRole === "merchant" && merchantData?.businessName) {
      return merchantData.businessName;
    }
    if (userRole === "influencer") {
      return (
        profile?.data?.name ||
        profile?.data?.displayName ||
        user?.name ||
        "Influencer"
      );
    }
    return user?.name || null;
  };
  const displayName = getDisplayName();

  // Logout handler for dropdown
  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
      setIsLoggingOut(false);
    }
  };

  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileDropdownRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Check if user is logged in (either from login or signup)
  const isLoggedIn =
    isUserAuthenticated &&
    (loggedInUser?.status === status.SUCCESS || localStorage.getItem("token"));
  // console.log("isLoggedIn:", isLoggedIn);
  // Sidebar menu items based on role
  const influencerMenuItems = [
    {
      path: "/influencer",
      label: "Dashboard",
      icon: <img src={DashboardIcon} alt="Dashboard" />,
    },
    {
      path: "/influencer/dashboard",
      label: "Earnings",
      icon: <img src={Earnings_icon} alt="Earnings" />,
    },
    {
      path: "/influencer/exclusive-deals",
      label: "Exclusive Deals Proposals",
      icon: <img src={Exclusiveicon} alt="Exclusive Deals Proposals" />,
    },
    // { path: "/influencer/promote-deals", label: "Promote Deals", icon: <img src={Promote_icon} alt="Promote Deals" /> },
    // { path: "/incoming-requests", label: "Received Proposals", icon: <img src={Received_icon} alt="Received Proposals" /> },
    // { path: "/sent-requests", label: "Sent Proposals", icon: <img src={Proposals_icon} alt="Sent Proposals" /> },
    {
      path: "/influencer/collaborations",
      label: "Collaborations",
      icon: <img src={Collaborations_icon} alt="Collaborations" />,
    },
    {
      path: "/influencer/transactions",
      label: "Transactions",
      icon: <img src={transaction_icon} alt="Transactions" />,
    },
    // { path: "/influencer/payout", label: "Request Payout", icon: "💳" },
    {
      path: "/influencer/payouts",
      label: "Payout History",
      icon: <img src={payout_icon} alt="Payout History" />,
    },
    {
      path: "/influencer/kyc",
      label: "Verification & Payouts",
      icon: <img src={settings} alt="Verification & Payouts" />,
    },
    {
      path: "/influencer/profile/edit",
      label: "Edit Profile",
      icon: <img src={editicon} alt="Edit Profile" />,
    },
  ];

  const merchantMenuItems = [
    {
      path: "/",
      label: "Dashboard",
      icon: <img src={DashboardIcon} alt="Dashboard" />,
    },
    {
      path: "/dashboard",
      label: "Earnings",
      icon: <img src={Earnings_icon} alt="Earnings" />,
    },
    {
      path: "/deals",
      label: "Create Deal",
      icon: <img src={CreateIcon} alt="Create Deal" />,
    },
    {
      path: "/reports",
      label: "Reports",
      icon: <img src={reports_icon} alt="Reports" />,
    },
    {
      path: "/orders",
      label: "Order Listing",
      icon: <img src={OrderListingicon} alt="Order Listing" />,
    },
    // { path: "/deals-details", label: "Deal Details", icon: "📋" },
    {
      path: "/merchant/deal-proposals",
      label: "Exclusive Deal Proposals",
      icon: <img src={Exclusiveicon} alt="Exclusive Deals Proposals" />,
    },
    // { path: "/incoming-requests", label: "Received Proposals", icon: <img src={CreateIcon2} alt="Received Proposals" /> },
    // { path: "/sent-requests", label: "Sent Proposals", icon: <img src={CreateIcon3} alt="Sent Proposals" /> },
    // {
    //   path: "/merchant/commissions",
    //   label: "Commission Dashboard",
    //   icon: <img src={CreateIcon4} alt="Commission Dashboard" />
    // },
    // { path: "/merchant/transactions", label: "Transactions", icon: "💰" },
    {
      path: "/merchant/payouts",
      label: "Payout History",
      icon: <img src={payout_icon} alt="Payout History" />,
    },
    // { path: "/upload", label: "Upload", icon: "📤" },
    {
      path: "/?tab=settings",
      label: "Settings",
      icon: <img src={settings} alt="Settings" />,
    },
  ];

  // Get menu items based on user role
  const menuItems =
    userRole === "influencer" ? influencerMenuItems : merchantMenuItems;

  const ToggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  // Skeleton Loader Component
  const HeaderSkeleton = () => (
    <header className="header-area header-skeleton">
      <div className="container">
        <div className="header-view">
          <div className="header-left">
            <div className="logo skeleton-logo">
              <div className="skeleton-box skeleton-logo-box"></div>
            </div>
          </div>
          <div className="header-right">
            {!isLoggedIn ? (
              <ul>
                <li>
                  <div className="skeleton-box skeleton-button"></div>
                </li>
              </ul>
            ) : (
              <>
                <div className="skeleton-box skeleton-button"></div>
                <div className="skeleton-box skeleton-notification"></div>
                <div className="skeleton-box skeleton-menu"></div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );

  return (
    <app-header>
      {isLoading ? (
        <HeaderSkeleton />
      ) : (
        <header className="header-area">
          <Helmet>
            <meta name="title" content={cfg && cfg.Meta_Title} />
            <meta name="keywords" content={cfg && cfg.Keywords} />
          </Helmet>
          <div className="container">
            <div className="header-view">
              {/* <div className="header-left"> */}
              <div className="header-left">
                <div className="logo">
                  <NavLink
                    to="/"
                  >
                    <img
                      src={
                        cfg?.Merchant_header_logo
                          ? `${ASSET_BASE}${cfg.Merchant_header_logo}`
                          : HeaderLogo
                      }
                      alt="header-logo"
                    />
                    {/* <img src={HeaderLogo} alt="" /> */}
                  </NavLink>
                </div>
              </div>
              {/* </div> */}
              {/* <div className="col-lg-8"> */}
              <div className="header-right">
                {/* <div className="search-icon">
                  <img src={SearchIcon} alt="" />
                </div> */}
                {!isLoggedIn && (
                  <ul>
                    {/* <li>
                      <NavLink
                        to="/login"
                        className={() => ""}
                      >
                        Sign Up
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        to="/login"
                        className={({ isActive }) =>
                          isActive ||
                            location.pathname === "/login"
                            ? "primary-btn active"
                            : "primary-btn"
                        }
                        title="Sign In"
                      >
                        Sign In
                      </NavLink>
                    </li>
                  </ul>
                )}
                {isLoggedIn && (
                  <div
                    className="header-profile-dropdown-wrapper"
                    ref={profileDropdownRef}
                  >
                    {/* Trigger Button — hidden entirely when no name is available */}
                    {displayName && (
                      <div
                        className="header-profile-trigger"
                        onClick={() =>
                          setShowProfileDropdown(!showProfileDropdown)
                        }
                      >
                        {/* Avatar — profile image, first-letter fallback, hidden when no name */}
                        <div className="profile-avatar">
                          {profileImage && !hasProfileImageError ? (
                            <img
                              src={profileImage}
                              alt={displayName}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "50%",
                              }}
                              onError={() => setHasProfileImageError(true)}
                            />
                          ) : (
                            displayName.charAt(0).toUpperCase()
                          )}
                        </div>

                        {/* Username */}
                        <span
                          className="profile-username-text"
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                            maxWidth: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {displayName}
                        </span>

                        {/* Dropdown Arrow */}
                        {/* <svg
                      width="12" height="12" viewBox="0 0 12 12" fill="none"
                      style={{
                        transform: showProfileDropdown ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.2s ease",
                      }}
                    >
                      <path d="M2 4L6 8L10 4" stroke="#be1622" strokeWidth="2"
                        strokeLinecap="round" strokeLinejoin="round" />
                    </svg> */}
                      </div>
                    )}

                    {/* Dropdown Menu */}
                    {/* {showProfileDropdown && (
                    <div style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      right: 0,
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                      minWidth: "223px",
                      zIndex: 9999,
                      overflow: "hidden",
                      border: "1px solid #f0f0f0",
                    }}> */}
                    {/* Merchant Dropdown Items */}
                    {/* {userRole === "merchant" && (
                        <> */}
                    {/* Order Listing */}
                    {/* <div
                            onClick={() => {
                              navigate("/orders");
                              setShowProfileDropdown(false);
                            }}
                            style={{
                              display: "flex", alignItems: "center", gap: "12px",
                              padding: "14px 18px", cursor: "pointer",
                              fontSize: "14px", color: "#333", fontWeight: "500",
                              borderBottom: "1px solid #f5f5f5",
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef2f2"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                          >
                            <img src={Order_Listing_icon} alt="" className="order_icon" />
                            Order Listing
                          </div> */}

                    {/* Exclusive Deal Proposals */}
                    {/* <div
                            onClick={() => {
                              navigate("/merchant/deal-proposals");
                              setShowProfileDropdown(false);
                            }}
                            style={{
                              display: "flex", alignItems: "center", gap: "12px",
                              padding: "14px 18px", cursor: "pointer",
                              fontSize: "14px", color: "#333", fontWeight: "500",
                              borderBottom: "1px solid #f5f5f5",
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef2f2"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                          >
                            <img src={Exclusiveicon} alt="" className="order_icon" />
                            Exclusive Deal Proposals
                          </div>
                        </>
                      )} */}

                    {/* Influencer Dropdown Items */}
                    {/* {userRole === "influencer" && (
                        <> */}
                    {/* Influencer Profile */}
                    {/* <div
                            onClick={() => {
                              navigate("/influencer");
                              setShowProfileDropdown(false);
                            }}
                            style={{
                              display: "flex", alignItems: "center", gap: "12px",
                              padding: "14px 18px", cursor: "pointer",
                              fontSize: "14px", color: "#333", fontWeight: "500",
                              borderBottom: "1px solid #f5f5f5",
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef2f2"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                          >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                stroke="#003049" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <circle cx="12" cy="7" r="4" stroke="#003049"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Influencer
                          </div> */}

                    {/* Exclusive Deal Proposals */}
                    {/* <div
                            onClick={() => {
                              navigate("/influencer/exclusive-deals");
                              setShowProfileDropdown(false);
                            }}
                            style={{
                              display: "flex", alignItems: "center", gap: "12px",
                              padding: "14px 18px", cursor: "pointer",
                              fontSize: "14px", color: "#333", fontWeight: "500",
                              borderBottom: "1px solid #f5f5f5",
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef2f2"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                          > */}
                    {/* <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                  stroke="#003049" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <polyline points="14 2 14 8 20 8"
                                  stroke="#003049" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg> */}
                    {/* <img src={Exclusiveicon} alt="" className="order_icon" style={{ width: '17px', filter: 'brightness(0) invert(0.2)' }} />
                            Exclusive Deal Proposals
                          </div>
                        </>
                      )} */}

                    {/* Logout - Common for both roles */}
                    {/* <div
                        onClick={() => {
                          handleLogout();
                          setShowProfileDropdown(false);
                        }}
                        style={{
                          display: "flex", alignItems: "center", gap: "12px",
                          padding: "14px 18px", cursor: "pointer",
                          fontSize: "14px", color: "#be1622", fontWeight: "500",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef2f2"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                            stroke="#be1622" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <polyline points="16 17 21 12 16 7"
                            stroke="#be1622" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <line x1="21" y1="12" x2="9" y2="12"
                            stroke="#be1622" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {isLoggingOut ? "Logging out..." : "Logout"}
                      </div>
                    </div> */}
                    {/* )} */}
                  </div>
                )}
                {/* <img src={MenuIcon} alt="" className="menu-icon" /> */}
                {/* {isLoggedIn && <span className="role-badge">
                {userRole === "influencer"
                  ? "Influencer"
                  : "Merchant"}
              </span>} */}
                {isLoggedIn && (
                  <>
                    <div
                      className="notification-icon"
                      onClick={handleNotificationClick}
                      style={{ cursor: "pointer" }}
                      title="View Notifications"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                          stroke="#be1622"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                          stroke="#be1622"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {unreadCount > 0 && (
                        <span className="notification-badge">
                          {unreadCount > 99 ? "99+" : unreadCount}
                        </span>
                      )}
                    </div>
                    <div className="header_menu">
                      <img
                        src={MenuIcon}
                        alt=""
                        // className={"menu-icon" + (menuOpen ? "" : "")}
                        // onClick={() => setMenuOpen(!menuOpen)}
                        className={`menu-icon ${isOpen == true ? "open" : ""}`}
                        onClick={ToggleSidebar}
                      />

                      {/* {menuOpen && ( */}
                      <>
                        <div
                          // className={"menu-box" + (menuOpen ? " show" : "")}
                          className={`menu-box ${isOpen == true ? "open" : ""}`}
                          ref={sidebarRef}
                        >
                          <div className="sidebar-header">
                            <img
                              src={BackIcon}
                              alt="back"
                              className="back-icon"
                              onClick={ToggleSidebar}
                            />
                            {/* {isLoggedIn && <span className="role-badge">
                            {userRole === "influencer"
                              ? "Influencer"
                              : "Merchant"}
                          </span>} */}
                          </div>

                          {/* {isLoggedIn && (
                          <div className="sidebar-user-info">
                            <div className="user-avatar">
                              {user?.name?.charAt(0)?.toUpperCase() || "U"}
                            </div>
                            <div className="user-details">
                              <span className="user-name">
                                {user?.name || "User"}
                              </span>
                              <span className="user-email">
                                {user?.email || ""}
                              </span>
                            </div>
                          </div>
                        )} */}

                          <nav className="sidebar-nav scroll-area">
                            {isLoggedIn &&
                              menuItems.map((item, index) => (
                                <div
                                  key={index}
                                  className={`sidebar-link ${activeLink === item.path ? "active" : ""}`}
                                  onClick={() => {
                                    // Check if this is "Create Deal" and merchant has no business name
                                    if (
                                      item.path === "/deals" &&
                                      userRole === "merchant" &&
                                      (!merchantData?.businessName ||
                                        merchantData.businessName.trim() === "")
                                    ) {
                                      // Navigate to home page and trigger modal
                                      setActiveLink(item.path);
                                      setIsOpen(false);
                                      navigate("/?showModal=true");
                                      return;
                                    }

                                    setActiveLink(item.path);
                                    setIsOpen(false);
                                    navigate(item.path);
                                  }}
                                >
                                  <span className="sidebar-icon">
                                    {item.icon}
                                  </span>
                                  <span className="sidebar-label">
                                    {item.label}
                                  </span>
                                </div>
                              ))}
                          </nav>
                          <div className="sidebar-footer">
                            <button
                              title="log out"
                              className="btn logout-btn"
                              disabled={isLoggingOut}
                              onClick={async () => {
                                setIsLoggingOut(true);
                                try {
                                  await logout();
                                } catch (err) {
                                  console.error("Logout failed:", err);
                                  setIsLoggingOut(false);
                                }
                              }}
                            >
                              {isLoggingOut ? "Logging out..." : "Log out"}
                            </button>
                          </div>
                        </div>
                      </>
                      {/* )} */}
                    </div>
                  </>
                )}
              </div>
              {/* </div> */}
            </div>
          </div>
        </header>
      )}
    </app-header>
  );
}

export default Header;
